import $ = require('jquery');
import Modul from './Modul';

/**
 * Video module class
 */
export default class ModulVideo extends Modul {
    constructor(moduleId: number) {
        super(moduleId);

        $('input.videoUrlField.mod_video_' + moduleId).click(function() {
            (Modul.getInstance(moduleId) as ModulVideo).modVideoSetInputFocus(this);
        });
        $('input.videoUrlField.mod_video_' + moduleId).keypress(
                function() {
                    (Modul.getInstance(moduleId) as ModulVideo).modVideoSetInputFocus(this);
                });
        $('input.mod_video_' + moduleId + '[name=videoType]').change(
                function() {
                    let textfieldname = $(this).val() + '_url';
                    $('input.mod_video_' + moduleId + '[name=' + textfieldname + ']').focus();
                });
        $('input#videoType_youtube_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'youtube',
            cls: 'no-label'
        });
        $('input#videoType_myvideo_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'myvideo',
            cls: 'no-label'
        });
        $('input#videoType_sevenload_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'sevenload',
            cls: 'no-label'
        });
        $('input#videoType_blip_' + moduleId).diy_radiobox({
            name: 'videoType',
            value: 'blip',
            cls: 'no-label'
        });

    }
    modVideoSetInputFocus(objekt: string|JQuery|HTMLElement) {
        let radioBtnId = 'videoType_'
                + $(objekt).attr('name').replace('_url', '');
        let radioBtn = $('#' + radioBtnId + '_' + this.moduleId);
        radioBtn.prop('checked', true);
        radioBtn.change();
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulVideo.ts
 **/